import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { ActionIcons } from '../../Iconography';
export const DownloadButton = ({ filename, data }) => {
    const [url, setURL] = useState('');
    useEffect(() => {
        const b = new Blob([data], { type: 'text/plain' });
        const u = URL.createObjectURL(b);
        setURL(u);
        return () => {
            URL.revokeObjectURL(u);
        };
    }, [data]);
    return (_jsx(Button, { variant: "contained", startIcon: _jsx(ActionIcons.Download, {}), size: "small", disabled: url.length === 0, onClick: () => {
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
        }, children: "Download" }));
};
